"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledFilterChipWithMenu = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _FilterChipWithMenuMixin = require("../../mixins/components/FilterChipWithMenuMixin");
var StyledFilterChipWithMenu = /*#__PURE__*/_styledComponents.default.label.withConfig({
  displayName: "StyledFilterChipWithMenu",
  componentId: "c11n-8-107-0__sc-ve3d1m-0"
})(["", ""], _FilterChipWithMenuMixin.FilterChipWithMenuMixin);
exports.StyledFilterChipWithMenu = StyledFilterChipWithMenu;